import { TuiInput, TuiTextfield, TuiCalendar } from '@taiga-ui/core';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  OnInit,
} from '@angular/core';
import {
  FormBuilder,
  FormGroupDirective,
  ReactiveFormsModule,
} from '@angular/forms';
import { TuiInputDate } from '@taiga-ui/kit';
import { RequestDTO } from '@core/types/Request';
import { IsoStringTuiDateTransformerDirective } from '@core/directives/isoStringTuiDateTransformer.directive';
import { RequestService } from '@core/services/request/request.service';
import { TranslatePipe } from '@ngx-translate/core';

enum FormFields {
  Contract = 'contract',
  ContractDate = 'contractDate',
  ContractPlannedEndDate = 'contractPlannedEndDate',
  ContractEarlyEndDate = 'contractEarlyEndDate',
}

type FormType = Pick<
  RequestDTO,
  | 'contract'
  | 'contractDate'
  | 'contractPlannedEndDate'
  | 'contractEarlyEndDate'
>;

@Component({
  selector: 'x-request-form-common-contract',
  imports: [
    TuiTextfield,
    TuiCalendar,
    ReactiveFormsModule,
    TuiInput,
    TuiInputDate,
    IsoStringTuiDateTransformerDirective,
    TranslatePipe,
  ],
  templateUrl: './request-form-common-contract.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFormCommonContractComponent implements OnInit {
  protected readonly FormFields = FormFields;
  private readonly formBuilder = inject(FormBuilder);
  private readonly parentForm = inject(FormGroupDirective);
  private readonly requestService = inject(RequestService);
  protected formGroup = this.formBuilder.group<FormType>({
    [FormFields.Contract]: null,
    [FormFields.ContractDate]: null,
    [FormFields.ContractPlannedEndDate]: null,
    [FormFields.ContractEarlyEndDate]: null,
  });

  $readOnly = input<boolean>(false, { alias: 'readOnly' });

  constructor() {
    effect(() => {
      if (this.$readOnly()) {
        this.formGroup.disable();
      }
    });
  }

  ngOnInit() {
    this.formGroup.patchValue(this.requestService.$request());
    this.parentForm.form.addControl('contract', this.formGroup);
  }
}
